import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';
import { siteConfig } from '@/mocks/siteConfig';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: `${siteConfig.name} - 首页`,
            description: siteConfig.description,
            url: siteConfig.url,
            isPartOf: {
              '@type': 'WebSite',
              name: siteConfig.name,
              url: siteConfig.url,
            },
            about: {
              '@type': 'Organization',
              name: siteConfig.name,
              description: siteConfig.tagline,
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '什么是开运风水？开运风水真的有效吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '开运风水是中国传统文化中关于环境能量学的智慧体系。它通过调整居住和工作环境的布局、方位、色彩等元素，优化气场流动，从而达到提升运势的效果。',
                },
              },
              {
                '@type': 'Question',
                name: '如何选择适合自己的开运饰品？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '选择开运饰品需要综合考虑生肖和五行属性，明确自己的开运需求，并听从自己的直觉，选择让自己感到舒适的那一款。',
                },
              },
              {
                '@type': 'Question',
                name: '命理测算准确吗？如何正确看待测算结果？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '命理测算揭示的是先天趋势和可能性，而非绝对的命运定论。后天的努力、选择和修行对人生轨迹的影响同样重要。建议将测算结果作为了解自我的参考工具。',
                },
              },
              {
                '@type': 'Question',
                name: '开运物品需要如何维护和保养？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '开运物品需要每月至少净化一次，保持清洁，避免他人随意触摸，如果出现破损应及时更换。',
                },
              },
            ],
          }),
        }}
      />

      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <FaqSection />
        <CtaSection />
      </main>
    </>
  );
}